import React from 'react';
import TimePicker from '@/components/shared/TimePicker';

interface TimeSelectorsProps {
  time: string;
  onTimeChange: (value: string) => void;
  timeError?: string;
  label?: string;
  handleBlur: (e: React.FocusEvent<any>) => void;
  formikId: string;
  touched: boolean;
}

const DEFAULT_TIME = '09:00';

const TimeSelectors: React.FC<TimeSelectorsProps> = ({
  time,
  onTimeChange,
  timeError,
  label,
  handleBlur,
  formikId,
  touched,
}) => {
  return (
    <>
      <div>
        <TimePicker
          value={time}
          onChange={onTimeChange}
          label={label}
          onBlur={() => {
            handleBlur({ target: { name: formikId } } as any);
            if (!time) {
              onTimeChange(DEFAULT_TIME);
            }
          }}
        />
        {timeError && touched && (
          <div className="mt-1 text-xs text-red-500">{timeError}</div>
        )}
      </div>
    </>
  );
};

export default TimeSelectors;
